<div class="grid grid-cols-1 md:grid-cols-1 lg:grid-cols-1 gap-4">
  <div class="flex items-center" *ngIf="attachments?.length > 0">
    <div
      class="text-[color:var(--Darkest-Grey,#21252A)] font-roboto text-[16px] !w-[8vw]"
    >
      {{ label }}
    </div>
    <!-- Download attachment -->
    <a
      target="_blank"
      *ngFor="let attachment of attachments"
      class="!mx-[10px]"
      #downloadDocumentLink
      [href]="docUrl || '#'"
      [ngClass]="{
        'text-black font-roboto text-[14px] font-normal leading-normal cursor-pointer underline': true,
        'text-black font-roboto text-[14px] font-normal leading-normal': true
      }"
    >
      {{ attachment?.title }}
    </a>
  </div>
</div>
<!-- (click)="
$event.stopPropagation();
downloadDocument(
  $event,
  downloadDocumentLink,
  attachment?.id,
  attachment?.file_path
)
" -->
